/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./audit-overview-api/api";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getImbalances = /* GraphQL */ `query GetImbalances(
  $material: String
  $size: String
  $month: String!
  $filter: ImbalanceFilter
  $isPersistent: Boolean
  $excludeColors: Boolean
  $nextToken: String
) {
  getImbalances(
    material: $material
    size: $size
    month: $month
    filter: $filter
    isPersistent: $isPersistent
    excludeColors: $excludeColors
    nextToken: $nextToken
  ) {
    items {
      material
      size
      quality
      coo
      wmsQty
      ciBondedQty
      ciNonBondedQty
      ciTotalQty
      imbalance
      persistentImbalance
      direction
      cleanStatus
      flowInformation
      __typename
    }
    nextToken
    totalCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetImbalancesQueryVariables,
  APITypes.GetImbalancesQuery
>;

export const getImbalancesForExport = /* GraphQL */ `query GetImbalancesForExport(
  $material: String
  $size: String
  $month: String!
  $filter: ImbalanceFilter
  $isPersistent: Boolean
  $excludeColors: Boolean
  $nextToken: String
) {
  getImbalances(
    material: $material
    size: $size
    month: $month
    filter: $filter
    isPersistent: $isPersistent
    excludeColors: $excludeColors
    nextToken: $nextToken
  ) {
    items {
      material
      size
      quality
      coo
      imbalance
      direction
      cleanStatus
      persistent1m
      persistent2m
      persistent3m
      persistent4m
      persistent6m
      persistent12m
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetImbalancesQueryVariables,
  APITypes.GetImbalancesQuery
>;
